import api from "./api";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadInsurance(documentId, siteId) {
  return async (dispatch, getState) => {
    let insuranceData = getState().currentOffer.insuranceData;
    if (insuranceData.insuranceLoaded) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_STARTED, payload: { documentId, siteId } });
    try {
      let insurance = await dispatch(sendHttpRequest(api.getInsurance(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_SUCCEEDED, payload: { ...insurance, hisOwnInsurance: false } }); // BCR will not use HisOwnInsurance check
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCompanies(documentId, siteId) {
  return async (dispatch, getState) => {
    let insuranceData = getState().currentOffer.insuranceData;
    if (insuranceData.companiesLoaded) {
      return;
    }
    dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_COMPANIES_STARTED, payload: { documentId, siteId } });
    try {
      let companies = await dispatch(sendHttpRequest(api.getInsuranceCompanies(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_COMPANIES_SUCCEEDED, payload: companies });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_COMPANIES_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadInsuranceProducts(documentId, siteId) {
  return async (dispatch /*, getState*/) => {
    dispatch({ type: actionTypes.LOAD_OFFER_INSURANCE_PRODUCTS_STARTED, payload: { documentId, siteId } });
    try {
      let products = await dispatch(sendHttpRequest(api.getInsuranceProducts(documentId, siteId)));
      dispatch({
        type: actionTypes.LOAD_OFFER_INSURANCE_PRODUCTS_SUCCEEDED,
        payload: { documentId, siteId, products }
      });
    } catch (error) {
      dispatch({
        type: actionTypes.LOAD_OFFER_INSURANCE_PRODUCTS_FAILED,
        payload: { documentId, siteId, error }
      });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function saveInsurance(documentId, siteId, insurance) {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_OFFER_INSURANCE_STARTED, payload: { documentId, siteId, insurance } });
    dispatch(
      sendHttpCommandAndWaitForEvent(api.saveInsurance(documentId, siteId, insurance), "SaveOfferInsuranceInProgress", [
        eventTypes.OFFER_INSURANCE_UPDATED
      ])
    )
      .then(event => {
        if (event.ok) {
          dispatch({ type: actionTypes.SAVE_OFFER_INSURANCE_SUCCEEDED, payload: { documentId, siteId, insurance } });
        } else {
          dispatch({
            type: actionTypes.SAVE_OFFER_INSURANCE_FAILED,
            payload: { documentId, siteId, insurance, error: event }
          });
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.SAVE_OFFER_INSURANCE_FAILED, payload: { documentId, siteId, insurance, error } });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function cancelInsuranceChanges(documentId, siteId) {
  return { type: actionTypes.CANCEL_OFFER_INSURANCE_CHANGES, payload: { documentId, siteId } };
}
